import { useState } from "react";
import { useSelectContext } from "../../../hooks/useSelectContext";

/**
 * Open state and field wiring for a Create * select.
 *
 * @param {string} name Formik field that receives the new id.
 * @param {string} context Select context.
 * @param {function(number): void=} onCreated Extra handler after select.
 * @return {{
 *   open: boolean,
 *   setOpen: function(boolean): void,
 *   drawerProps: {
 *     open: boolean,
 *     onClose: function(): void,
 *     onCreated: function(number): void
 *   }
 * }}
 */
export const useQuickCreateSelect = (name, context, onCreated) => {
  const [open, setOpen] = useState(false);
  const {
    formik: { setFieldValue },
  } = useSelectContext(context);

  return {
    open,
    setOpen,
    drawerProps: {
      open,
      onClose: () => setOpen(false),
      onCreated: id => {
        if (id != null) setFieldValue(name, id);
        onCreated?.(id);
        setOpen(false);
      },
    },
  };
};
